var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18082 14.8149C2.30092 14.9359 2.45899 14.996 2.61706 14.996C2.77498 14.996 2.93304 14.9351 3.05404 14.8149L8.00009 9.86883L12.9465 14.8149C13.0668 14.9359 13.2247 14.996 13.3828 14.996C13.5399 14.996 13.6979 14.9351 13.8189 14.8149C14.06 14.5738 14.06 14.1829 13.8189 13.9418L8.87302 8.99589L13.8189 4.05005C14.06 3.8088 14.06 3.41792 13.8189 3.17682C13.5778 2.93573 13.1869 2.93573 12.9458 3.17682L7.99988 8.12274L3.05404 3.17682C2.8128 2.93573 2.42192 2.93573 2.18082 3.17682C1.93973 3.41792 1.93973 3.8088 2.18082 4.05005L7.1269 8.99572L2.18082 13.9418C1.93973 14.1829 1.93973 14.5738 2.18082 14.8149Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdelete);
export default __webpack_public_path__ + "static/media/idelete.2d5199b155834169ec0cf18ae1eb2f98.svg";
export { ForwardRef as ReactComponent };